import { get, split } from 'lodash';

import { BACKGROUND_TYPES } from 'constants/landingPage';
import Model from 'models';

const HeroSlideModel = class extends Model {
  get backgroundType() {
    const landscapeContentType = get(this._data, ['heroAssetLandscape', 'file', 'contentType']);
    const portraitContentType = get(this._data, ['heroAssetPortrait', 'file', 'contentType']);
    const landscapeAssetType = get(split(landscapeContentType, '/'), 0);
    const portraitAssetType = get(split(portraitContentType, '/'), 0);

    let landscapeBackgroundType = '';
    let portraitBackgroundType = '';

    if (landscapeAssetType === 'image') {
      landscapeBackgroundType = BACKGROUND_TYPES.IMAGE;
    } else if (landscapeAssetType === 'video') {
      landscapeBackgroundType = BACKGROUND_TYPES.VIDEO;
    }

    if (portraitAssetType === 'image') {
      portraitBackgroundType = BACKGROUND_TYPES.IMAGE;
    } else if (portraitAssetType === 'video') {
      portraitBackgroundType = BACKGROUND_TYPES.VIDEO;
    }

    return {
      landscape: landscapeBackgroundType,
      portrait: portraitBackgroundType,
    };
  }

  get backgroundAsset() {
    const landscapeData = get(this._data, 'heroAssetLandscape');
    const portraitData = get(this._data, 'heroAssetPortrait');

    return {
      landscape: {
        src: get(landscapeData, ['file', 'url']),
        alt: get(landscapeData, ['description']),
        width: get(landscapeData, ['file', 'details', 'image', 'width']),
        height: get(landscapeData, ['file', 'details', 'image', 'height']),
      },
      portrait: {
        src: get(portraitData, ['file', 'url']),
        alt: get(portraitData, ['description']),
        width: get(portraitData, ['file', 'details', 'image', 'width']),
        height: get(portraitData, ['file', 'details', 'image', 'height']),
      },
    };
  }

  get svgAssetDesktop() {
    return get(this._data, 'svgAssetDesktop');
  }

  get svgAssetMobile() {
    return get(this._data, 'svgAssetMobile');
  }

  get eyebrow() {
    return get(this._data, 'eyebrow');
  }

  get heading() {
    return get(this._data, 'heading');
  }

  get subheading() {
    return get(this._data, 'subheading');
  }

  get ctaLinks() {
    return get(this._data, 'ctaLinks');
  }

  get isInverted() {
    return get(this._data, 'isInverted');
  }
};

export default HeroSlideModel;
